import type { Ctx } from "../../types";
import { Query } from "gg-wf-scripts";
import { decorateSchool } from "./_helpers";

export const school_by_id: Query<Ctx> = async ({ sb }, params) => {
  const id = params.get("id");
  if (!id) return null;

  const { data } = await sb
    .from("v_schools_list")
    .select("*")
    .eq("id", id)
    .single();
  if (!data) return null;

  const admins: { label: string; value: string }[] = data.admins ?? [];
  return {
    ...decorateSchool(data),
    f_admins: admins.map((a) => a.label).join(", "),
  };
};
